import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ClassificationService } from '../../../core/services/classification/classification/classification.service'
import { ErrorRequestModel, ResponseRequestModel } from '../../../core/models/response.model'
import {NgIf} from '@angular/common';

@Component({
  selector: 'classification-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatInputModule,
    MatFormField,
    MatInput,
    MatLabel,
    NgIf,
  ],
  templateUrl: './classification-edit-component.html',
  styleUrls: ['./classification-edit-component.scss'],
  providers: [ClassificationService],
  standalone: true,
})
export class ClassificationEditComponent implements OnInit {
  @Output() responseEdit = new EventEmitter<boolean>()

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  itemEdit: any = {}

  constructor(
    private formBuilder: FormBuilder,
    private alertService: ClassificationService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ClassificationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.itemEdit = data
  }

  ngOnInit(): void {
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
      name: [this.itemEdit.label_completo, [Validators.required]],
      priority: [this.itemEdit.prioridade, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      descricao: this.form.controls['description'].value,
      nome: this.form.controls['name'].value,
      prioridade: this.form.controls['priority'].value,
    }
  }

  updateItem() {
    if (this.form.invalid) return

    this.loading = true
    const model = this.createModel()
    console.log(model, 'model')
    this.alertService.editAlert(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  close() {
    this.dialogRef.close()
  }
}
